import { makeElement } from "../../../common/Utils";
import l10n from "../../L10n";
import { copyText } from "../../Utils";
import { AbsSocial } from "./AbsSocial";

export class CopyText extends AbsSocial {
    name: SocialName = 'copy';

    constructor(protected ElShareUList: HTMLElement, protected option: ShareOption){
        super(ElShareUList, option);

        this.init();
    }

    addEvent(){
        this.ElBtn.addEventListener('click', async () => {
            await copyText(this.option.shareUrl);
            alert(l10n[this.option.langCode].successMsg)
        })
    }

}
